<mat-card style="background-color:white" class="snackbar-card">
    <h4 class="text-black w-100 p-2 pt-4 text-center">Une nouvelle version est disponible</h4>
    <mat-divider [style.border-top-color]="'rgba(0,0,0,.12)'"></mat-divider>

    <mat-card-content class="d-flex flex-column justify-content-around align-items-center text-center h-100 m-4">
        <h5 class="text-black w-100 p-2 text-center">Sauvegardez vos changements et rafraichissez la page</h5>

        <div *ngIf="latestReleaseNote" class="latest-release-note">
            <div class="note-header">
                <span class="version">Version {{latestReleaseNote.version}}</span>
                <span class="date">{{latestReleaseNote.date | date:'dd/MM/yyyy'}}</span>
            </div>
            <h6 class="note-title">{{latestReleaseNote.title}}</h6>
            <p class="note-description">{{latestReleaseNote.description}}</p>
            <a class="view-all-link" (click)="goToReleaseNotes()">Voir toutes les notes de version</a>
        </div>

        <button mat-raised-button class="btn-pulpo" (click)="reload()">Rafraichir</button>
    </mat-card-content>
</mat-card>
